import { emperor } from "~/services";

export const getLeadsAudit = async () => {
    return await emperor.get(`/audit/leads`);
};

export const getConfigAudit = async () => {
    return await emperor.get(`/audit/config`);
}
